/**
 * Decode HEIC/HEIF to JPEG client-side. Browsers other than Safari can't
 * render HEIC in an <img> or decode it via createImageBitmap, so it has to
 * be converted before upload for it to be viewable anywhere else.
 */
export async function convertHeicIfNeeded(file: File): Promise<File> {
  if (file.type !== 'image/heic' && file.type !== 'image/heif') return file;

  try {
    const heic2any = (await import('heic2any')).default;
    const result = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.82 });
    const blob = Array.isArray(result) ? result[0] : result;
    const name = file.name.replace(/\.[^./]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg' });
  } catch {
    return file;
  }
}
